import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import IndustriesPage from "./pages/IndustriesPage";
import ContactPage from "./pages/ContactPage";

// SEO Component
const SEO = ({ title, description }) => {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", description);
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", title);
    
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", description);
  }, [title, description]);
  
  return null;
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App noise-overlay">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <SEO 
                  title="ANJO Consultants | Performance, Governance & Transformation"
                  description="Enterprise-grade consulting for strategy, finance, operations, and AI governance. Helping private, public, and quasi organizations deliver measurable results."
                />
                <HomePage />
              </>
            } />
            <Route path="/about" element={
              <>
                <SEO 
                  title="About ANJO Consultants | Governance-First Consulting"
                  description="Learn about ANJO Consultants' mission, values, and approach to helping organizations improve performance through disciplined governance."
                />
                <AboutPage />
              </>
            } />
            <Route path="/services" element={
              <>
                <SEO 
                  title="Services | ANJO Consultants"
                  description="Strategy, finance advisory, technology consulting, data readiness, and AI/LLM governance services for enterprise organizations."
                />
                <ServicesPage />
              </>
            } />
            <Route path="/industries" element={
              <>
                <SEO 
                  title="Industries We Serve | ANJO Consultants"
                  description="Serving private industry, public sector, and quasi-government organizations with tailored consulting solutions."
                />
                <IndustriesPage />
              </>
            } />
            <Route path="/contact" element={
              <>
                <SEO 
                  title="Contact ANJO Consultants"
                  description="Get in touch with ANJO Consultants. We respond within 1 business day to discuss your organization's needs."
                />
                <ContactPage />
              </>
            } />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
